import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c2cc1f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Trabalho ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Nome:")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Celular:")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Telefone:")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("E-mail:")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Site Web:")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("QR-Code")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Carrinho")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Limpar")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Exemplo")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_base_layout = _resolveComponent("base-layout")!

  return (_openBlock(), _createBlock(_component_base_layout, {
    "show-back-arrow": "true",
    "page-title": "QR-Code Social",
    "page-default-back-link": "/frontpage"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_ion_checkbox, { checked: _ctx.isWork }, null, 8, ["checked"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_ion_input, {
            modelValue: _ctx.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
            placeholder: "Nome e Sobrenome"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_ion_input, {
            modelValue: _ctx.cel,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cel) = $event)),
            placeholder: "exemplo: (21)99999-9999"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_ion_input, {
            modelValue: _ctx.tel,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tel) = $event)),
            placeholder: "exemplo: (21)2345-6789"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_ion_input, {
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
            placeholder: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_ion_input, {
            modelValue: _ctx.site,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.site) = $event)),
            placeholder: "http://site.com"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_textarea, {
            rows: "2",
            modelValue: _ctx.address,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.address) = $event)),
            placeholder: "Rua, Número e Complemento;Cidade;Estado;CEP"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            size: "small",
            onClick: _ctx.generate,
            disabled: !_ctx.itsOkToGenerate
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(_component_ion_button, {
            size: "small",
            color: "success",
            onClick: _ctx.doCar,
            disabled: _ctx.qrcode == '' || _ctx.canCar==false
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(_component_ion_button, {
            size: "small",
            onClick: _ctx.clear
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_ion_button, {
            size: "small",
            onClick: _ctx.example
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, { class: "ion" }, {
        default: _withCtx(() => [
          (_ctx.qrcode!='')
            ? (_openBlock(), _createBlock(_component_ion_img, {
                key: 0,
                src: _ctx.qrcode,
                "router-link": "/car",
                width: "150",
                height: "150",
                alt: "qr-code"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, { class: "minor" }, {
            default: _withCtx(() => [
              _createTextVNode(" Lat: " + _toDisplayString(_ctx.location.latitude) + " Long:" + _toDisplayString(_ctx.location.longitude) + " Acc:" + _toDisplayString(_ctx.location.accuracy), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}